/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import { observable, action } from 'mobx';

export default class AppSectionBasedField {
    @observable appSectionFilter = [];

    localizedTagline;

    @observable subText;

    @observable seeMoreLink;

    @observable localizedUpdateDescription = [];

    showStatusLabel = false;

    updateTileVersion;

    isHeaderClickable;

    // flag to determine if only session error status is to be shown
    // in an app section
    showSessionErrorOnly;

    isCategorySection;

    displayLearnMoreIcon;

    displayEducationIcon;

    availablePlatforms = [];

    seeMoreLinkUrl;

    iconText;

    isCardClickable = false;

    lastUpdateType; // update mode when product was last updated

    showDropDown;

    @observable statusLabelList;

    @observable buttonList = [];

    @observable dropDownList = [];

    @action removeDropDownItem(dropDownItem) {
        this.dropDownList.remove(dropDownItem);
    }

    @action setAvailablePlatforms(availablePlatforms) {
        this.availablePlatforms = availablePlatforms;
    }

    @action setAppSectionFilter(appSectionFilter) {
        this.appSectionFilter = appSectionFilter;
    }

    @action setSubText(subText) {
        this.subText = subText;
    }

    @action setSeeMoreLink(seeMoreLink) {
        this.seeMoreLink = seeMoreLink;
    }

    @action setLocalizedUpdateDescription(description) {
        this.localizedUpdateDescription = description;
    }

    @action setButtonList(buttonList) {
        this.buttonList = buttonList;
    }

    @action setDropDownList(dropDownList) {
        this.dropDownList = dropDownList;
    }

    @action setStatusLabelList(statusLabelList) {
        this.statusLabelList = statusLabelList;
    }

    constructor({
        appSectionFilter, localizedTagline, subText, seeMoreLink, localizedUpdateDescription,
        availablePlatforms, buttonList, dropDownList, seeMoreLinkUrl,
        isHeaderClickable = true, displayLearnMoreIcon = true,
        lastUpdateType, iconText, showStatusLabel, updateTileVersion, isCardClickable,
        showDropDown = true, showSessionErrorOnly, displayEducationIcon, isCategorySection,
        statusLabelList = [],
    }) {
        this.appSectionFilter = appSectionFilter;
        this.subText = subText;
        this.seeMoreLink = seeMoreLink;
        this.localizedTagline = localizedTagline;
        this.localizedUpdateDescription = localizedUpdateDescription;
        this.availablePlatforms = availablePlatforms;
        this.buttonList = buttonList;
        this.dropDownList = dropDownList;
        this.seeMoreLinkUrl = seeMoreLinkUrl;
        this.isHeaderClickable = isHeaderClickable;
        this.displayLearnMoreIcon = displayLearnMoreIcon;
        this.lastUpdateType = lastUpdateType;
        this.iconText = iconText;
        this.showStatusLabel = showStatusLabel;
        this.updateTileVersion = updateTileVersion;
        this.isCardClickable = isCardClickable;
        this.displayEducationIcon = displayEducationIcon;
        this.showDropDown = showDropDown;
        this.showSessionErrorOnly = showSessionErrorOnly;
        this.isCategorySection = isCategorySection;
        this.statusLabelList = statusLabelList;
    }
}
